import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { APIClient } from "../../../helpers/ApiHelper";

export const convertTargetAudience = createAsyncThunk(
    "convertTargetAudience",
    async (audienceId, thunkAPI) => {
        try {
            const apiClient = new APIClient();
            const response = await apiClient.post(`/api/v1/management/audience/${audienceId}/convert/target`);

            if (response.status === true) {
                return { success: true, message: "Conversion to target audience successful." };
            } else {
                return thunkAPI.rejectWithValue({ success: false, message: "Conversion failed." });
            }
        } catch (error) {
            return thunkAPI.rejectWithValue({ success: false, message: error.message });
        }
    }
);

const convertTargetAudienceReducer = createSlice({
    name: 'convertTargetAudience',
    initialState: {
        isLoading: false,
        success: false,
        message: '',
    },
    extraReducers: {
        [convertTargetAudience.pending]: (state) => {
            state.isLoading = true;
        },
        [convertTargetAudience.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.success = action.payload.success;
            state.message = action.payload.message;
        },
        [convertTargetAudience.rejected]: (state, action) => {
            state.isLoading = false;
            state.success = action.payload.success;
            state.message = action.payload.message;
        },
    },
});

export default convertTargetAudienceReducer.reducer;
